'use strict';

class PopupManager {
    constructor(config = {}) {
        this.config = {
            touch: false,
            autoFocus: false,
            smallBtn: true,
            toolbar: false,
            modal: false,
            clickSlide: false,
            clickOutside: false,
            mobile: {
                clickSlide: (current) => current.type === "image" ? "toggleControls" : false
            },
            ...config
        };
    }

    getInstance() {
        let instance = jQuery.fancybox.getInstance();
        if (!instance) {
            this.loading();
            instance = jQuery.fancybox.getInstance();
        }
        return instance;
    }

    loading(args = {}) {
        //this.close();
        jQuery.fancybox.open(
            '<div class="fancybox-loading"></div>',
            {...jQuery.fancybox.defaults, ...this.config, ...args}
        );
    }

    setContent(content) {
        const instance = this.getInstance();
        instance.current.$slide.trigger("onReset");
        instance.setContent(instance.current, content);
    }

    error() {
        const instance = this.getInstance();
        instance.setError(instance.current);
    }

    close() {
        jQuery.fancybox.close();
    }
}

window.popupManager = new PopupManager();
